var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "seal-container" },
    [
      !_vm.isChoosed
        ? _c("div", { staticClass: "seal", on: { click: _vm.chooseSeal } }, [
            _c("span", { staticClass: "sealIcon" }, [_vm._v("+")]),
            _vm._v(" "),
            _c("span", [_vm._v("添加印章")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isChoosed
        ? _c(
            "div",
            {
              staticClass: "seal_choosed",
              style: {
                left: _vm.posX ? _vm.posX + "px" : 0,
                top: _vm.posY ? _vm.posY + "px" : 0,
              },
              on: { click: _vm.chooseSeal },
            },
            [
              _c("img", {
                staticClass: "sealImg",
                attrs: {
                  src: _vm.seal.url ? _vm.seal.url : _vm.seal.sealBase64,
                  alt: "",
                },
              }),
              _vm._v(" "),
              _vm.canDelete
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showDelete,
                          expression: "showDelete",
                        },
                      ],
                      staticClass: "sealDeleteButton",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.deleteSeal.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n      删除\n    ")]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "seal-list",
        _vm._b(
          {
            ref: "sealList",
            attrs: { show: _vm.showList },
            on: { "choose-seal": _vm.choosed },
          },
          "seal-list",
          { elecseal: _vm.elecseal, esignature: _vm.esignature },
          false
        )
      ),
      _vm._v(" "),
      _c("purpose-pc", {
        attrs: { show: _vm.showPurpose },
        on: { "check-succ": _vm.checkSucc },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }